import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HUNPartyColorsService } from './hun-party-colors.service';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    exports: [],
    providers: [
        HUNPartyColorsService
    ]
})
export class HUNPartyColorsModule {

}
